var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"indicator"}},_vm._l((_vm.array),function(index){return _c('div',{key:index,staticClass:"dot-box"},[_c('span',{staticClass:"dot",class:{'active': index === _vm.currentIndex},on:{"click":function($event){return _vm.handleClick(index)}}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }